// extracted by mini-css-extract-plugin
export var errorIcon = "_m3-1";
export var nameLogo = "_m3-0";